import Container from 'typedi';
import IHTTPClientAdapter from '../adapters/HTTPClientAdapter/IHTTPClientAdapter';
import documentTypes from '../resources/documentTypes';

class DocumentRepository {
  httpClientAdapter;
  lastmileApiUrl;
  constructor() {
    this.httpClientAdapter = Container.get(IHTTPClientAdapter);
    this.lastmileApiUrl = Container.get('ENV_LASTMILE_API_URL');
  }

  /**
   * Retorna los tipos de documentos
   * @returns {object[]} {id: number, value: string}
   */
  getTypes() {
    return documentTypes;
  }
  /**
   * Retorna un tipo de documento que coincida con el id deseado
   * @returns {object?} {id: number, value: string}
   */
  getType(id) {
    return documentTypes.find((type) => type.id === id);
  }

  async getDocumentsByIdOperation(idOperation) {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/operation-document?idOperation=${idOperation}`;
    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      console.log("Dato documento",response.data);
      return response.data;
    } catch (e) {
      return [];
    }
  }
  async getDocumentsByIdActivity(idActivity) {
    const clientId = Container.get('clientId');
    const accessToken = Container.get('accessToken');
    const url = `${this.lastmileApiUrl}/activity/${idActivity}`;
    try {
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      const response = await this.httpClientAdapter.get(url, config);
      return response.data.documents;
    } catch (e) {
      return [];
    }
  }

  async getDocuments(page, rowsPerPage) {
    try {
      const clientId = Container.get('clientId');
      const accessToken = Container.get('accessToken');
      const url = `${this.lastmileApiUrl}/document?pageNum=${page}&pageSize=${rowsPerPage}`;
      const config = {
        headers: {
          'id-client': clientId,
          Authorization: `Bearer ${accessToken}`,
        }
      };
      return await this.httpClientAdapter.get(url, config);
    } catch (e) {
      console.log(e);
      return {
        data: [],
        paginator: {
          totalRows: 0,
        },
      };
    }
  }
}

Container.set({ id: DocumentRepository, type: DocumentRepository });

export default DocumentRepository;
